import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isSelected", "children"];
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export function FilterEditorWrapper(_ref) {
  let {
      isSelected,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(View, Object.assign({
    display: "inline-block",
    backgroundColor: isSelected ? 'fill-secondary-subtle' : undefined
  }, props, {
    children: children
  }));
}